module.exports = __webpack_public_path__ + "static/media/adoc-icon.5c33c0f1.svg";